'use client';

import { Keyboard, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import ResponsiveImage, { type ResponsiveImageData } from '@/components/atoms/ResponsiveImage';

export default function VenueImageSwiper({ images }: { images: ResponsiveImageData[] }) {
    // Filter out images that don't have the required fields
    const validImages = images.filter(
        (image) => image?.urlMedium && image?.widthMedium && image?.heightMedium
    );

    if (validImages.length === 0) {
        return null;
    }

    return (
        <Swiper
            spaceBetween={50}
            slidesPerView={1}
            navigation={true}
            keyboard={{
                enabled: true,
                onlyInViewport: true,
                pageUpDown: true,
            }}
            modules={[Navigation, Keyboard]}
            className={'pb-12 text-sm leading-6'}
            tabIndex={0}
            aria-roledescription="carousel"
        >
            {validImages.map((image, index) => (
                <SwiperSlide
                    key={image?.id}
                    role="tabpanel"
                    aria-roledescription="slide"
                    aria-label={`Slide ${index + 1} of ${validImages.length}`}
                >
                    <ResponsiveImage
                        image={image}
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px"
                        fallbackAlt="Venue image"
                    />
                </SwiperSlide>
            ))}
        </Swiper>
    );
}
